import { render, staticRenderFns } from "./NotFoundComponent.vue?vue&type=template&id=fc50663a"
import script from "./NotFoundComponent.vue?vue&type=script&lang=ts"
export * from "./NotFoundComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports